var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuscle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#C9E2F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.778 38.9268C85.778 38.9268 88.8541 43.6577 83.489 45.7349C78.7781 47.561 76.8555 43.9871 76.8555 43.9871L81.2503 40.4073L85.778 38.9268Z",
    fill: "url(#paint0_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2138 63.1455C55.2138 66.8519 59.3711 73.9613 55.1313 79.4918L55.1595 79.5742L77.8502 78.6501L101 83.0335V108C101 108 94.0806 105.648 84.6528 105.648C75.225 105.648 68.4949 108 61.6641 108C54.8334 108 53.2006 103.104 42.8125 103.104C28.9618 103.104 29 96.1093 29 93.6183C29 80.3074 33.9182 67.4526 39.8672 56.1445L55.2138 63.1455Z",
    fill: "url(#paint1_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5711 86.2783C38.5711 86.2783 56.0376 82.7447 55.9208 82.8612C55.8041 82.9777 65.0668 94.2777 65.0668 94.2777C59.6553 93.7795 53.4547 93.4601 46.3682 93.4601C43.3947 93.4601 43.4551 95.8085 40.5642 95.8085C37.6732 95.8085 37.9369 93.2351 37.9369 93.2351L38.5711 86.2783Z",
    fill: "url(#paint2_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7351 91.186C84.3934 91.2845 88.0111 91.8208 89.4626 91.8208C90.7209 91.8208 94.7855 85.9328 98.2684 89.4062C99.8729 91.0093 97.6966 94.1311 95.4277 94.7739C100.759 93.9683 100.39 99.6997 97.0906 99.772C93.8172 99.8443 86.7166 97.1283 73.3369 95.238L83.7351 91.186Z",
    fill: "url(#paint3_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4792 78.757C45.3331 78.1041 44.9828 81.7161 46.7785 81.7161C47.9603 81.7161 51.0687 80.9969 55.1595 79.5746C57.2894 78.8333 59.6851 77.9012 62.2137 76.7782C69.5961 73.5037 75.0458 72.8227 83.9663 75.8521C92.8848 78.8815 95.9831 78.7911 101 76.9028V83.0339C96.1844 82.1259 92.9854 84.418 86.3097 89.4342C85.44 90.0871 84.5783 90.6697 83.7348 91.186C78.1019 94.6432 73.3366 95.2359 73.3366 95.2359C70.8101 94.8783 68.058 94.5508 65.0664 94.2776C59.5442 93.5263 56.6372 87.1521 51.0988 87.1521C45.1539 87.1521 46.7906 91.2683 43.6983 91.2683C40.6061 91.2683 40.5638 88.6507 40.5638 88.6507L37.5098 82.8591L40.4792 78.757Z",
    fill: "url(#paint4_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9453 23C79.4281 23 91.155 29.7097 91.155 32.7029C91.155 35.4892 88.9888 37.2912 86.734 37.2912C86.6112 37.2912 86.4884 37.2832 86.3656 37.2651H86.3636L75.9453 23Z",
    fill: "url(#paint5_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9407 60.6204C39.7181 59.0113 39.861 56.2471 39.8671 56.1446C44.3464 47.6229 49.4117 39.9831 53.3998 33.6873C54.5493 31.8712 56.2082 30.4329 58.1731 29.555C63.2463 27.287 73.1976 23 75.9456 23C75.9456 23 83.022 29.5891 85.0754 33.1569C85.9009 34.5893 86.4263 36.0417 86.3639 37.2651C86.3498 37.8678 86.1445 38.4483 85.778 38.9265C85.0614 39.8365 83.642 40.407 81.2504 40.407C80.6263 41.9599 79.2513 43.2616 76.8556 43.9868C76.775 44.013 76.6945 44.0371 76.612 44.0592C76.2355 45.6442 75.1645 46.747 72.9097 46.747C70.6549 46.747 69.4389 45.7466 68.984 44.5774C65.634 45.7667 61.3539 46.1384 61.3539 46.1384C55.6969 51.7813 55.2137 59.2082 55.2137 63.1456C50.1525 64.9918 44.3766 62.6273 44.3766 62.6273L41.9407 60.6204Z",
    fill: "url(#paint6_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7207 56.5684C45.4058 57.1087 46.0178 58.3241 45.0575 61.3234C44.8199 61.7292 44.5945 62.1651 44.377 62.6272C42.2149 67.2335 41.0351 74.3751 40.4795 78.7565C40.1856 81.0687 40.0648 82.6136 40.0648 82.6136C40.0648 82.6136 43.7207 82.708 43.7207 85.4461C43.7207 88.1842 40.564 88.6503 40.564 88.6503C40.564 88.6503 38.1059 89.2228 38.7381 91.1855C39.0159 91.973 38.6757 92.8428 37.9368 93.2346C37.4456 93.4877 36.8718 93.5299 36.3484 93.3511C35.3639 93.0075 34.7056 92.0794 34.7097 91.0388C34.6392 80.9241 35.5532 75.4278 41.9411 60.6203C42.4927 59.3426 43.0866 57.9927 43.7207 56.5684Z",
    fill: "url(#paint7_linear_971_984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5253 44.0391C76.0462 43.9266 75.7201 43.4826 75.7563 42.9945C75.9798 39.8827 74.035 35.1437 73.1875 33.4342C72.9358 32.94 73.1331 32.3353 73.6304 32.0842C74.1075 31.8431 74.6893 32.0159 74.9571 32.4779C74.9933 32.5382 78.0775 38.7115 77.7614 43.1512C77.7171 43.7016 77.232 44.1114 76.6803 44.0652C76.628 44.0612 76.5757 44.0532 76.5253 44.0411V44.0391Z",
    fill: "#F99D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1718 44.5047C68.6524 44.7056 68.0665 44.4465 67.8652 43.9282C67.8169 43.8016 67.7927 43.667 67.7988 43.5324C67.8471 41.8751 69.0651 40.3765 71.2272 40.045C71.7768 39.9606 72.2922 40.3383 72.3748 40.8867C72.3808 40.9249 72.3848 40.9631 72.3848 41.0032C72.3889 41.5215 72.0104 41.9615 71.497 42.0358C70.5991 42.1824 69.8401 42.6947 69.8099 43.5846C69.8019 43.9925 69.5482 44.3561 69.1698 44.5067L69.1718 44.5047Z",
    fill: "#F99D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5499 39.2582C81.0391 36.9179 79.8211 34.1175 78.2508 32.2091C77.9085 31.8093 77.9186 31.2187 78.277 30.831C78.6655 30.4332 79.3017 30.4272 79.7003 30.8149C79.7265 30.839 79.7506 30.8651 79.7728 30.8932C81.5484 33.0327 83.1952 36.4759 82.5248 39.662C82.402 40.2044 81.8645 40.5439 81.3209 40.4234C80.7935 40.3049 80.4532 39.7906 80.5519 39.2603L80.5499 39.2582Z",
    fill: "#F99D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9607 81.9186C88.9305 81.9065 85.6832 80.6771 80.1208 80.0443C79.5692 79.982 79.1726 79.4838 79.235 78.9314C79.2974 78.3809 79.7967 77.9852 80.3483 78.0475C86.1946 78.7144 89.5466 79.9921 89.6875 80.0463C90.2069 80.2452 90.4646 80.8278 90.2653 81.344C90.066 81.8623 89.4822 82.1195 88.9648 81.9206H88.9628L88.9607 81.9186Z",
    fill: "#D24F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0902 89.1687C78.903 88.6464 79.1768 88.0719 79.7002 87.885C82.5267 86.8424 85.164 85.3418 87.5033 83.4454C87.9241 83.0818 88.5603 83.128 88.9226 83.5479C89.285 83.9677 89.2407 84.6025 88.82 84.9641C86.2954 87.0273 83.4407 88.6545 80.3766 89.7774C79.8532 89.9642 79.2774 89.691 79.0902 89.1687Z",
    fill: "#D24F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7442 83.6686C66.9525 83.5602 63.8944 82.5557 61.9275 81.8486C63.2502 81.1857 65.4748 80.35 68.8066 79.9361C69.3583 79.8678 69.7488 79.3656 69.6804 78.8152C69.6119 78.2647 69.1086 77.875 68.557 77.9433C61.8148 78.783 59.1091 81.2419 58.9983 81.3464C58.5937 81.7281 58.5756 82.3669 58.9581 82.7727C59.0567 82.8771 59.1775 82.9595 59.3104 83.0137C59.562 83.1142 65.513 85.4887 68.6214 85.6775C69.1771 85.7117 69.6542 85.2898 69.6864 84.7354C69.7206 84.1809 69.2979 83.7048 68.7422 83.6727L68.7442 83.6686Z",
    fill: "#D24F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9378 90.6414C63.2743 89.8519 60.7095 88.7571 58.2997 87.379C57.8226 87.0937 57.6695 86.477 57.9554 86.0009C58.2413 85.5268 58.8573 85.3721 59.3345 85.6554C61.5993 86.9411 64.0051 87.9656 66.5014 88.7129C67.0349 88.8676 67.343 89.4261 67.1859 89.9584C67.0309 90.4908 66.4712 90.7981 65.9378 90.6414Z",
    fill: "#D24F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0436 84.3558C78.961 83.8074 79.3375 83.2951 79.8871 83.2128C81.1856 83.038 82.466 82.7347 83.7061 82.3088C84.2276 82.1159 84.8074 82.3831 84.9986 82.9034C85.1899 83.4237 84.9241 84.0023 84.4027 84.1931C83.0357 84.6672 81.6225 85.0027 80.1891 85.1976C79.6395 85.2799 79.1261 84.9043 79.0436 84.3558Z",
    fill: "#D24F75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_984",
    x1: 79.2854,
    y1: 37.8339,
    x2: 86.7762,
    y2: 51.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F9B6A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C3A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_984",
    x1: 65,
    y1: 108,
    x2: 65,
    y2: 56.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D86876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EA7984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FA8791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_971_984",
    x1: 51.4978,
    y1: 95.8085,
    x2: 51.4978,
    y2: 82.8592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEC7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FED7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFE5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFEDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_971_984",
    x1: 86.4247,
    y1: 99.774,
    x2: 86.4247,
    y2: 88.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEC7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FED7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFE5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFEDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_971_984",
    x1: 69.2559,
    y1: 95.2379,
    x2: 69.2559,
    y2: 73.9135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D24F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E35E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F36B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FC7399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF759B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_971_984",
    x1: 81.1313,
    y1: 31.0556,
    x2: 88.1843,
    y2: 24.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9A49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F9B5A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9C0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C3A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_971_984",
    x1: 63.1155,
    y1: 63.8507,
    x2: 63.1155,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9A49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F9B5A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F9C0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C3A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_971_984",
    x1: 34.7056,
    y1: 75.014,
    x2: 45.5125,
    y2: 75.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FEC7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FED7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFE5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFEDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 85,
    fill: "white",
    transform: "translate(29 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscle);
export default __webpack_public_path__ + "static/media/Muscle.3f8926211fe5065c5acf1b2599937357.svg";
export { ForwardRef as ReactComponent };